import { createContext } from "react";

export const ArticulosCombosContext = createContext()
export const ArticulosCombosFormContext = createContext()
export const ArticulosCombosReportContext = createContext()